//@flow

import { graphql, useStaticQuery } from "gatsby";
import React, { createRef, useEffect } from "react";
import Form from "react-bootstrap/Form";

import Select from "@/components/CountrySelect/AsterismSelect";

type Props = {
    bsCustomPrefix?: string;
    htmlSize?: number;
    size?: 'sm' | 'lg';
    plaintext?: boolean;
    readOnly?: boolean;
    disabled?: boolean;
    value?: string | string[] | number;
    onChange?: (event: {target: {name: string, value: string}}) => void;
    custom?: boolean;
    type?: string;
    name?: string;
    id?: string;
    isValid?: boolean;
    isInvalid?: boolean;
    placeholder?: string;
}

const CountrySelect = (props: Props): React$Element<any> => {
    const ref = createRef<any>();
    const countries = useStaticQuery(graphql`
        query AllCountriesQuery {
            allCountries {
                nodes {
                    code
                    name
                    id
                }
            }
        }
    `).allCountries.nodes;

    const options = countries.map(country => (
        <option key={country.id} value={country.code}>
            {country.name}
        </option>
    ));

    useEffect(() => {
        let select;
        if (ref.current != null) {
            select = new Select(ref.current, {
                filtered: "auto",
                filter_threshold: 8,
                filter_placeholder: "Search...",
            });
        }

        return () => select.deinit();
    });

    return (
        <Form.Control ref={ref} as="select" {...props}>
            {props.placeholder && <option value="">{props.placeholder}</option>}
            {options}
        </Form.Control>
    );
};

export default CountrySelect;
